module.exports = __webpack_public_path__ + "img/type_back2.132b56cf.jpg";